// // src/pages/Sidebar.jsx
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { 
  Package, 
  ShoppingCart, 
  TrendingUp, 
  Truck,  
  X, 
} from 'lucide-react';

// const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
//   const location = useLocation();
  // const currentPath =
  //   location.pathname === '/' ? 'dashboard' : location.pathname.replace('/', '').toLowerCase();

//   const sidebarData = [
//     { label: 'Dashboard', link: 'AgroAdminPanel' },
//     { label: 'Product', link: 'product' },
//     { label: 'Orders', link: 'orders' },
//     { label: 'Settings', link: 'settings' },
//   ];

//   return (
//     <aside
//       className={`fixed z-50 inset-y-0 left-0 w-64 bg-white    transform transition-transform duration-300 ease-in-out
//         ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
//         md:relative md:translate-x-0 md:block`}
//     >
//       {/* Header */}
//       <div className="flex items-center justify-between p-6 border-b">
//         <h1 className="text-2xl font-bold text-green-600">Polar Agro</h1>
//         {/* Mobile Close Button */}
//         <button
//           onClick={() => setSidebarOpen(false)}
//           className="md:hidden text-gray-600 focus:outline-none"
//         >
//           <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth="2">
//             <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
//           </svg>
//         </button>
//       </div>

//       {/* Navigation Links */}
      // <nav className="mt-6 space-y-2 px-4">
      //   {sidebarData.map((item, index) => {
      //     const isActive = currentPath === item.link.toLowerCase();
      //     return (
      //       <Link
      //         key={index}
      //         to={`${item.link}`}
      //         onClick={() => setSidebarOpen(false)} // auto-close on mobile
      //         className={`block px-4 py-4 rounded-md text-sm font-medium ${
      //           isActive
      //             ? 'bg-blue-500 text-white'
      //             : 'text-gray-700 hover:bg-gray-100'
      //         }`}
      //       >
      //         {item.label}
      //       </Link>
      //     );
      //   })}
      // </nav>
//     </aside>
//   );
// };

// export default Sidebar;
// 



// Sidebar Component
// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { Package, ShoppingCart, TrendingUp, Truck, X } from 'lucide-react'; // or whichever icons you use

const Sidebar = ({ active, setActive, sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  const currentPath = location.pathname === "/" ? "Dashboard" : location.pathname.replace("/", "");

  const menuItems = [
    { name: 'Dashboard', path: 'agroadminpanel', icon: Package },
    { name: 'Product', path: 'product', icon: Package },
    { name: 'Orders', path: 'orders', icon: ShoppingCart },
    { name: 'Shipments', path: 'shipments', icon: Truck },
    { name: 'changepassword', path: 'changepassword', icon: TrendingUp },
    { name: 'Logout', path: 'logout', icon: X },

  ];

  return (
    <>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-white transform transition-transform duration-300 ease-in-out
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 lg:static lg:inset-0`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b border-gray-200 lg:justify-center">
            <h2 className="text-lg font-semibold text-gray-800">Menu</h2>
            <button 
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-600"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <nav className="mt-6 space-y-2 px-4">
            {menuItems.map((item) => {
              const isActive = currentPath.split("/")[1] === item?.path.toLowerCase();
              console.log(currentPath.split("/"),item.path.toLowerCase(),"===",currentPath === item?.path);
              
              return (
                <Link
                  key={item?.name}
                  to={`${item?.path}`}
                  onClick={() => {
                    // setActive(item?.path);
                    setSidebarOpen(false);
                  }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-blue-500 text-white'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  <item.icon className="h-5 w-5" />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;